import React from 'react';

import { useEditableWidget } from '@lumapps/designer-legacy-widget-settings/hooks/useEditableWidget';
import type { EditableWidgetProps } from '@lumapps/designer-legacy-widget-settings/types';
import { BackendRecomputedWidget } from '@lumapps/widget-base/components/BackendRecomputedWidget';

import type { LegacyWidgetSummaryProps } from '../../types';
import { EditableWidgetSummary, EditableWidgetSummaryProps } from '../EditableWidgetSummary';

import './index.scss';

export interface LegacyWidgetSummaryWrapperProps extends EditableWidgetProps<LegacyWidgetSummaryProps> {}

export interface EditableWidgetBlockProperties {
    text?: string;
}

export const LegacyWidgetSummaryWrapper: React.FC<LegacyWidgetSummaryWrapperProps> = ({
    legacyWidget: initLegacyWidget,
    switchToReadMode,
    saveTextInWidgetProperties,
    isEditingContent,
    isWidgetEmpty,
    contentTitle,
    ...props
}: LegacyWidgetSummaryWrapperProps) => {
    const getTranslateObject = React.useCallback((properties?: LegacyWidgetSummaryProps) => properties?.text, []);

    const { legacyWidget, content, editableWidgetProps } = useEditableWidget<LegacyWidgetSummaryProps>(
        initLegacyWidget,
        switchToReadMode,
        saveTextInWidgetProperties,
        getTranslateObject,
    );

    return (
        <BackendRecomputedWidget<LegacyWidgetSummaryProps, EditableWidgetBlockProperties, EditableWidgetSummaryProps>
            legacyWidget={legacyWidget}
            editableWidgetRenderer={EditableWidgetSummary}
            editableWidgetProps={{
                ...editableWidgetProps,
                contentTitle,
            }}
            isWidgetEmpty={isWidgetEmpty}
            blockProperties={{ text: content }}
            editingContent={isEditingContent}
            canUseLangFallback={false}
            {...props}
        />
    );
};
